import { render, staticRenderFns } from "./aboutTask.vue?vue&type=template&id=0ecab7dd&scoped=true&"
import script from "./aboutTask.vue?vue&type=script&lang=js&"
export * from "./aboutTask.vue?vue&type=script&lang=js&"
import style0 from "./aboutTask.vue?vue&type=style&index=0&id=0ecab7dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecab7dd",
  null
  
)

export default component.exports